export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";